// Deductions can only come from pay periods that have not run yet and that fall inside the permit's
// own term, so the cutoff is whichever of the two comes later.
export const resolvePurchaseStart = ({ optionStart, now }: { optionStart?: Date | null; now: Date }): Date =>
	optionStart && optionStart > now ? optionStart : now;
